import { render, staticRenderFns } from "./schedules.vue?vue&type=template&id=55ac54e0&scoped=true"
import script from "./schedules.vue?vue&type=script&lang=js"
export * from "./schedules.vue?vue&type=script&lang=js"
import style0 from "./schedules.vue?vue&type=style&index=0&id=55ac54e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ac54e0",
  null
  
)

export default component.exports